import styled from "@emotion/styled"

export const FullWidth = styled.div`
  width: 100vw;
  height: 400px;
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
`

export const BannerContentContainer = styled.div`
  text-align: center;
`

export const BannerTextContainer = styled.div`
  line-height: 1;
  justify-content: space-around;
  flex-direction: column;
  display: flex;
`
export const BannerTitle = styled.h1`
  color: white;
  padding: 0.25em;
  text-shadow: 2px 2px #603f8b;
`

export const BannerSubtitle = styled.h2`
  color: white;
  padding: 0.25em;
`

export const BannerButtonContainer = styled.div`
  padding: 2em 0.25em 0.25em 0.25em;
  a {
    margin: 10px;
  }
`
